module.exports = __webpack_public_path__ + "img/alternate_2_mobile.3982b5f.jpg";